/**
 * Copyright (c) 2021-2024 Kognitos, Inc. All rights reserved.
 */
import React from 'react';
import Icon from '@ant-design/icons';

function ProcessSvg(props: any) {
  const { fill } = props;
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_53_8206)">
        <path
          d="M7.20884 6.08548H20.1852C20.5752 6.08548 20.9292 6.24184 21.1851 6.49356C21.441 6.74529 21.6 7.09344 21.6 7.47703V22.2524C21.6 22.4442 21.4421 22.6 21.2466 22.6H8.30305C8.10805 22.6 7.94962 22.4447 7.94962 22.2524V16.4528H6.11357C5.91857 16.4528 5.76013 16.2974 5.76013 16.1051V7.50882C5.76013 7.12888 5.91433 6.78178 6.1639 6.52536L6.1851 6.50295C6.44686 6.24548 6.80931 6.08496 7.20778 6.08496L7.20884 6.08548ZM7.95068 15.7591V9.19327V7.50986C7.95068 7.30869 7.86749 7.12627 7.73396 6.99546C7.60148 6.86464 7.41973 6.78334 7.21891 6.78125H7.20884C7.00536 6.78125 6.8199 6.8636 6.68584 6.99546L6.66942 7.01057C6.54489 7.14035 6.46753 7.3165 6.46753 7.51038V15.7596L7.95068 15.7591ZM8.65702 9.19327V16.1062V21.9058H20.8942V7.47807C20.8942 7.2868 20.8147 7.1122 20.6859 6.98608C20.5577 6.85995 20.3802 6.78125 20.1857 6.78125H8.45089C8.58177 6.99494 8.65702 7.24458 8.65702 7.51038V9.19327Z"
          fill={fill || '#1D1D37'}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.36348 6.67817L6.34307 6.69974C6.13609 6.9124 6.01013 7.19797 6.01013 7.50882V16.1051C6.01013 16.1552 6.05247 16.2028 6.11357 16.2028H8.19962V22.2524C8.19962 22.3025 8.24196 22.35 8.30305 22.35H21.2466C21.3077 22.35 21.35 22.3025 21.35 22.2524V7.47703C21.35 7.16406 21.2206 6.87911 21.0098 6.6718C20.799 6.46442 20.5073 6.33548 20.1852 6.33548H7.17199C6.85732 6.34466 6.57219 6.47436 6.36348 6.67817ZM6.00979 6.32471C6.31648 6.02306 6.74119 5.83496 7.20778 5.83496H7.26592L7.26698 5.83548H20.1852C20.6431 5.83548 21.0594 6.01925 21.3604 6.31533C21.6615 6.61148 21.85 7.02283 21.85 7.47703V22.2524C21.85 22.5859 21.5765 22.85 21.2466 22.85H8.30305C7.97415 22.85 7.69962 22.5869 7.69962 22.2524V16.7028H6.11357C5.78466 16.7028 5.51013 16.4396 5.51013 16.1051V7.50882C5.51013 7.06046 5.69204 6.65238 5.98345 6.35232L6.00979 6.32471ZM6.51373 6.8141C6.69226 6.64008 6.93858 6.53125 7.20884 6.53125H7.2215C7.48928 6.53403 7.73231 6.64266 7.90926 6.81722C8.08834 6.99284 8.20068 7.23859 8.20068 7.50986V16.009L6.21753 16.0097V7.51038C6.21753 7.24866 6.3222 7.01135 6.48903 6.83748L6.49441 6.83187L6.51373 6.8141ZM7.20884 7.03125C7.07376 7.03125 6.95049 7.08582 6.86115 7.17369L6.85521 7.17953L6.84501 7.18873C6.76565 7.27385 6.71753 7.38682 6.71753 7.51038V15.5095L7.70068 15.5092V7.50986C7.70068 7.37896 7.64678 7.26004 7.559 7.17404C7.4713 7.08744 7.35071 7.03294 7.21748 7.03125H7.20884ZM8.0046 6.53125H20.1857C20.4485 6.53125 20.6882 6.63765 20.8612 6.80776C21.0353 6.97843 21.1442 7.2163 21.1442 7.47807V22.1558H8.40702V7.51038C8.40702 7.29243 8.34545 7.08775 8.2377 6.91183L8.0046 6.53125ZM8.83561 7.03125C8.88203 7.18322 8.90702 7.34412 8.90702 7.51038V21.6558H20.6442V7.47807C20.6442 7.35743 20.5943 7.24623 20.511 7.16467C20.4276 7.08259 20.3119 7.03125 20.1857 7.03125H8.83561Z"
          fill={fill || '#1D1D37'}
        />
        <path
          d="M19.1998 9.7C19.1998 10.0866 18.8864 10.4 18.4998 10.4C18.1132 10.4 17.7998 10.0866 17.7998 9.7C17.7998 9.3134 18.1132 9 18.4998 9C18.8864 9 19.1998 9.3134 19.1998 9.7Z"
          fill={fill || '#1D1D37'}
        />
        <path
          d="M17.2999 9.7C17.2999 10.0866 16.9865 10.4 16.5999 10.4C16.2133 10.4 15.8999 10.0866 15.8999 9.7C15.8999 9.3134 16.2133 9 16.5999 9C16.9865 9 17.2999 9.3134 17.2999 9.7Z"
          fill={fill || '#1D1D37'}
        />
        <path
          d="M15.4 9.7C15.4 10.0866 15.0866 10.4 14.7 10.4C14.3134 10.4 14 10.0866 14 9.7C14 9.3134 14.3134 9 14.7 9C15.0866 9 15.4 9.3134 15.4 9.7Z"
          fill={fill || '#1D1D37'}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.5 15.5C10.5 15.2239 10.7239 15 11 15H19C19.2761 15 19.5 15.2239 19.5 15.5C19.5 15.7761 19.2761 16 19 16H11C10.7239 16 10.5 15.7761 10.5 15.5Z"
          fill={fill || '#1D1D37'}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.5 17C10.5 16.7239 10.7239 16.5 11 16.5H19C19.2761 16.5 19.5 16.7239 19.5 17C19.5 17.2761 19.2761 17.5 19 17.5H11C10.7239 17.5 10.5 17.2761 10.5 17Z"
          fill={fill || '#1D1D37'}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.5 18.5C10.5 18.2239 10.7239 18 11 18H19C19.2761 18 19.5 18.2239 19.5 18.5C19.5 18.7761 19.2761 19 19 19H11C10.7239 19 10.5 18.7761 10.5 18.5Z"
          fill={fill || '#1D1D37'}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.5 20C10.5 19.7239 10.7239 19.5 11 19.5H19C19.2761 19.5 19.5 19.7239 19.5 20C19.5 20.2761 19.2761 20.5 19 20.5H11C10.7239 20.5 10.5 20.2761 10.5 20Z"
          fill={fill || '#1D1D37'}
        />
      </g>
      <defs>
        <clipPath id="clip0_53_8206">
          <rect
            width="17"
            height="18"
            fill="white"
            transform="translate(5 5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export default function ProcessIcon(props: {
  style?: React.CSSProperties;
  fill?: string;
  height?: number;
  width?: number;
}) {
  return <Icon component={() => ProcessSvg(props)} {...props} />;
}
